import { render, staticRenderFns } from "./Concerns.vue?vue&type=template&id=40d3c00a&scoped=true&"
import script from "./Concerns.vue?vue&type=script&lang=js&"
export * from "./Concerns.vue?vue&type=script&lang=js&"
import style0 from "./Concerns.vue?vue&type=style&index=0&id=40d3c00a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d3c00a",
  null
  
)

export default component.exports